// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.display-flex-div[data-v-7f104c1d] {\n  display: flex;\n  flex-flow: row wrap;\n  border-bottom: 1px solid rgb(235, 237, 242);\n  width: 100%;\n}\n.display-flex-div > *[data-v-7f104c1d] {\n  width: 50%;\n  background-color: rgba(0, 0, 0, 0);\n  padding: 0.5rem;\n  border: 0;\n  word-break: break-word;\n}\n.tr-title[data-v-7f104c1d] {\n  font-weight: bold;\n}\n@media (max-width: 568px) {\n.display-flex-div > *[data-v-7f104c1d] {\n    width: 100%;\n}\n}\n", ""]);
// Exports
module.exports = exports;
